import { TYPEFORM_URL_PREFIX } from './constants'

export default function typeformUrlToId(url: string): string | null {
  if (url.length !== 37 || !url.startsWith(TYPEFORM_URL_PREFIX)) {
    return null
  }
  return url.slice(TYPEFORM_URL_PREFIX.length)
}
